import clsx from "clsx";
import { useRouter } from "next/router";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import classes from "./RecipesDetail.module.scss";

// regex pattern that checks if a string has at least two white spaces in a row or at least one tab character
const nonWfIngredientsRegex = /(\s{2,}|\t)/g;
interface NonWfIngredientProps {
  ingredient: string;
}

export const NonWfIngredient = ({ ingredient }: NonWfIngredientProps) => {
  const {
    query: { viewMode },
  } = useRouter();

  if (!ingredient) {
    return <br />;
  }

  if (!ingredient.match(nonWfIngredientsRegex)) {
    return <p>{ingredient}</p>;
  }

  const index = ingredient.search(nonWfIngredientsRegex);
  const ingredientText = ingredient.slice(0, index);
  const quantity = ingredient.slice(index);

  return (
    <p
      className={clsx(
        classes["non-wf-ingredient"],
        viewMode === KIOSK_VIEW_MODE_QUERY && classes.kiosk
      )}
    >
      <span>{ingredientText}</span>
      <span>{quantity.trim()}</span>
    </p>
  );
};
